import {eTipoPermissao} from '@/enums/ePermissoes';
import Index from '@/views/patrimonio/patbem/Index.vue';
import InclusaoEdicao from '@/views/patrimonio/patbem/InclusaoEdicao.vue';
import CadastroComGrid from '@/views/patrimonio/patbem/CadastroComGrid.vue';
export default [
 {
  description: 'Bem',
  path: '/patrimonio/patbem',
  name: 'patbem',
  component: Index,
  meta: {
   permissions: [eTipoPermissao.BEMNOVO_MENU_1200100199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Bem',
  path: '/patrimonio/patbem/cadastro/:id?',
  parent: 'patbem',
  name: 'patbem_create',
  component: InclusaoEdicao,
  meta: {
   permissions: [eTipoPermissao.BEMNOVO_MENU_1200100199],
  },
  goesToMenu: true,
 },
 {
  description: 'Histórico do Bem',
  path: '/patrimonio/patbem/:patBemId/historico',
  parent: 'patbem',
  name: 'patbem_historico',
  component: CadastroComGrid,
  meta: {
   permissions: [eTipoPermissao.BEMNOVO_MENU_1200100199],
  },
  goesToMenu: false,
 },
]
